import { useTranslation } from "react-i18next";
import { colors } from "../../../Styles";
import { TooltipString } from "../..";

export default function FeedLabel({contentString, labelColor, tooltip=true}:{contentString?: string, labelColor?: colors, tooltip?: boolean}) {
  const { t } = useTranslation();

  return (
    <TooltipString
      overrides={{ contentstring: { color: labelColor ? labelColor : colors.greyLightTertiary } }}
      tooltipString={ tooltip ? t(`animalPages.animals.kgFedMore`, {defaultValue:`KG fed more than expected` }) : undefined}
      contentString={
        <div style={{
          border: "1px solid " + ( labelColor ? labelColor : colors.greyLightTertiary),
          borderRadius: "10px",
          width: "40px",
          height: "15px",
          boxSizing: "border-box",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: "0",
          cursor: "pointer"
        }}>
          {contentString ? contentString : `•••`}
        </div>
      }
    />
  )
}